import React from "react";
import { Outlet } from "react-router-dom";
import SiteNav from "./SiteNav";
import SiteFooter from "./SiteFooter";

const PublicLayout = () => (
  <>
    <SiteNav />
    <Outlet />
    <SiteFooter />
  </>
);

export default PublicLayout;
